import axios from "../utils/axios"
export const ToDoListService = {
    addToDo: async (data) => {
        try {
            const response = await axios.post('/api/todolist/addTodo', data)
            if (response.data.success) {
                return response.data
            } else {
                throw response.data;
            }
        } catch (error) {
            throw error?.response?.data || { message: "Failed to add To Do List" };
        }
    },
    getToDoList: async (date) => {
        try {
            const response = await axios.get('/api/todolist/getTodoList', {
                params: { date }
            });
            if (response.data.success) {
                return response.data
            } else {
                throw response.data;
            }
        } catch (error) {
            throw error?.response?.data || { message: "Failed to fetch To Do List" };
        }
    },
    deleteToDo: async (id) => {
        try {
            const response = await axios.delete(`/api/todolist/deleteTodo/${id}`);
            return response.data;
        } catch (error) {
            throw error?.response?.data || { message: "Failed to delete To Do List" };
        }
    },

    getEmployeeTodoList: async (employeeId, date) => {
        try {
            const response = await axios.get(`/api/todolist/getTodoList/${employeeId}?date=${date}`);
            if (response.data.success) {
                return response.data
            }
        } catch (error) {
            throw error?.response?.data || { message: "Failed to fetch Employee To Do List" };
        }
    }
}
